/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import ClassNames from 'classnames';
import { InputBase, IconButton, Select, MenuItem, Button } from '@material-ui/core';
import Loader from '../../components/Loader';
const { selectDesktop } = Slices.appSlice;
const { selectAllProduct } = Slices.categorySlice;
import CartBar from '../../components/CartBar';
import SearchResultList from './SearchResultList';
import MiniCart from '../../components/MiniCart';
import { RiCloseLine } from '@react-icons/all-files/ri/RiCloseLine';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import LanguageButton from '../../components/LanguageButton';
import { debounce } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './index.module.scss';
import MobileHeader from '../../components/Header/MobileHeader';
import DesktopHeader from '../../components/Header/DesktopHeader';
import DownArrowIcon from '../Category/images/downArrow.svg';
import DefaultSelectionIcon from '../Category/images/defaultSelect.svg';
import classNames from 'classnames';
import CartSkelton from '../Cart/CartSkelton';
import { useNavigate } from '@reach/router';

const { useDispatch } = Redux;
const { getClusterId } = Slices.configSlice;
const { selectLoginStatus } = Slices.authSlice;
const { getPreviouslyOrderedProducts } = Slices.orderSlice;
const { fetchSearchTags, fetchSearchResults, addRecentSearches } = Slices.searchSlice;

function Search({ setOpenSearch, TabsContainer }) {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectLoginStatus);
  const [searchResults, setSearchResults] = React.useState([]);
  const [allProduct, setProducts] = React.useState(useSelector(selectAllProduct));

  const [pageLoader, setPageLoader] = useState(false);

  const isDesktop = useSelector(selectDesktop);
  const tagsState = useSelector((state) => state.tags);
  const searchState = useSelector((state) => state.search);
  const clusterId = useSelector(getClusterId);

  const [selectedCategoryTag, setSelectedCategoryTag] = useState(
    parseInt(window.localStorage.getItem('searchQTag') || 0)
  );
  const [searchTerm, setSearchTerm] = useState(window.localStorage.getItem('searchText') || '');
  const [categoryTags, setCategoryTags] = useState([]);

  useEffect(() => {
    if (isLoggedIn) {
      const payload = {
        isActive: 0,
        page: 1,
      };
      const debouncedDispatch = debounce(dispatch, 2500);
      debouncedDispatch(getPreviouslyOrderedProducts(payload));
      return () => {
        // Cancel the debounced function
        debouncedDispatch.cancel();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.getElementById('search_location').focus();

    if (searchState.status == 'idle') {
      dispatch(fetchSearchTags());
    }
  }, []);

  useEffect(() => {
    searchHandler();
  }, [selectedCategoryTag, searchTerm]);

  useEffect(() => {
    const tagsData =
      tagsState.status === 'succeeded'
        ? Object.values(tagsState.data || {}).sort((tag1, tag2) => tag1.position - tag2.position)
        : [];

    setCategoryTags(tagsData);
  }, [tagsState]);

  const searchHandler = async () => {
    try {
      if (!selectedCategoryTag && !searchTerm) {
        return;
      }
      setPageLoader((pre) => true);

      const payload = {
        skip: 0,
        limit: 20,
        cluster: clusterId,
      };

      if (selectedCategoryTag) {
        payload.qtag = selectedCategoryTag;
        window.localStorage.setItem(`searchQTag`, selectedCategoryTag);
        window.localStorage.removeItem(`searchText`);
      } else if (searchTerm) {
        payload.search = searchTerm.toLowerCase();
        window.localStorage.setItem(`searchText`, searchTerm.toLowerCase());
        window.localStorage.removeItem(`searchQTag`);
      }

      const resp = await dispatch(fetchSearchResults(payload));
      const responseList = resp?.payload?.list || [];
      if (responseList.length) {
        setSearchResults(responseList);
        setPageLoader((pre) => false);
      } else {
        setPageLoader((pre) => false);
        setSearchResults((pre) => []);
      }
      dispatch(addRecentSearches(searchTerm));
    } catch (error) {
      // Handle any errors here
      console.error('Error:', error);
      setPageLoader((pre) => false);
    }
  };

  const debouncedSearchHandler = debounce((e) => {
    // setPageLoader(true);
    setSearchTerm((p) => inputRef?.current?.value);
    setSelectedCategoryTag(0);
  }, 1000);

  const handleCategoryTagSelection = (tagId) => {
    if (tagId === selectedCategoryTag) {
      setSelectedCategoryTag((prev) => '');
      setPageLoader((pre) => false);
    } else {
      setPageLoader(true);
      setSelectedCategoryTag((prev) => tagId);
      setSearchTerm('');
      inputRef.current.value = '';
    }
  };

  const inputRef = React.useRef();
  const handlePageExist = (e) => {
    const prevPage = window.localStorage.getItem('beforeSearchLocation');
    if (prevPage) {
      window.localStorage.removeItem('beforeSearchLocation');
    }
    navigate(prevPage);

    if (setOpenSearch) {
      setOpenSearch(false);
    }
    setProducts((old) => allProduct);
  };

  const handleSearchText = (value) => {
    // setPageLoader(true);
    inputRef.current.value = value;
    setSearchTerm(value);
    setSelectedCategoryTag(0);
  };

  return (
    <>
      {pageLoader && <Loader />}
      {!isDesktop ? (
        <MobileHeader
          icon={<FaArrowLeft onClick={handlePageExist} />}
          searchBar={true}
          className={css.SearchBar}
          actionButtons={[
            <div className={css.searchI}>
              <InputBase
                id="search_location"
                inputRef={inputRef}
                placeholder={intl.formatMessage({
                  id: 'search_placeholder',
                })}
                onChange={debouncedSearchHandler}
              />
              <IconButton type="submit" className={css.iconButton} aria-label="search">
                <RiCloseLine onClick={handlePageExist} className={css.searchClose} />
              </IconButton>
            </div>,
          ]}
        />
      ) : (
        <DesktopHeader actionButtons={[<LanguageButton />]} />
      )}
      <div className={css.root}>
        {isDesktop && (
          <nav className={css.searchContainer}>
            <div className={ClassNames(css.searchInput)}>
              <InputBase
                id="search_location"
                inputRef={inputRef}
                placeholder={intl.formatMessage({
                  id: 'search_placeholder',
                })}
                onChange={debouncedSearchHandler}
              />

              <IconButton type="submit" className={css.iconButton} aria-label="search">
                <RiCloseLine onClick={handlePageExist} className={css.searchClose} />
              </IconButton>
            </div>
          </nav>
        )}
        <main className={css.main}>
          {!isDesktop && (
            <div className={css.tagsContainer}>
              {categoryTags.map((category) => {
                let categoryName =
                  category.tagName[intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)];
                return (
                  <Button
                    variant={'outlined'}
                    className={selectedCategoryTag == category.tagId ? css.selectedCategoryTag : ''}
                    onClick={() => handleCategoryTagSelection(category.tagId)}
                  >
                    {' '}
                    <img
                      src={
                        selectedCategoryTag === category.tagId
                          ? category.asset.selected
                          : category.asset.default
                      }
                      alt={categoryName}
                    />{' '}
                    {categoryName}
                  </Button>
                );
              })}
            </div>
          )}
          {/* TODO: Customize swipeable views for desktop */}
          <div className={ClassNames(isDesktop ? css.desktopWrapper : '')}>
            {/* TODO: calculation of height is incorrect */}
            <div className={css.searchList}>
              {isDesktop && (
                <>
                  <div className={css.tabContentHeader}>
                    <div className={css.tabContentTitle}>
                      {searchTerm || selectedCategoryTag ? (
                        <FormattedMessage
                          id="showing_x_items"
                          values={{ count: searchResults.length }}
                          defaultMessage={`Showing ${searchResults.length} Items`}
                        />
                      ) : (
                        <FormattedMessage id="category_search" defaultMessage="Search" />
                      )}
                    </div>
                    <div className={css.filterContainer}>
                      <Select
                        value={selectedCategoryTag}
                        label=""
                        displayEmpty
                        className={css.tagFilters}
                        disableUnderline={true}
                        IconComponent={() => <img src={DownArrowIcon} />}
                      >
                        <MenuItem
                          className={css.selectBoxItem}
                          value={0}
                          onClick={() => handleCategoryTagSelection(0)}
                        >
                          <span className={css.tagFilterItem}>
                            <img src={DefaultSelectionIcon} alt={'Select Tag'} />
                            <FormattedMessage id="filter_by" defaultMessage={'Filter By'} />
                          </span>
                        </MenuItem>
                        {categoryTags.map((category) => {
                          let categoryName =
                            category.tagName[
                              intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)
                            ];
                          return (
                            <MenuItem
                              value={category.tagId}
                              className={css.selectBoxItem}
                              onClick={() => handleCategoryTagSelection(category.tagId)}
                            >
                              <span className={css.tagFilterItem}>
                                <img src={category.asset.default} alt={categoryName} />{' '}
                                {categoryName}
                              </span>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </>
              )}
              {(!searchTerm || !!selectedCategoryTag || selectedCategoryTag == 0) &&
                !pageLoader &&
                searchResults.length > 0 && (
                  <>
                    {/* recent searches */}
                    {searchState?.recentSearches?.filter((s) => s?.length > 0)?.length > 0 && (
                      <div className={css.searchTag}>
                        <div className={css.searchTagTitle}>
                          <span>
                            <FormattedMessage id="recent_search" />
                          </span>
                        </div>
                        <div className={css.searchTagBtns}>
                          {searchState?.recentSearches?.map((searchItem) => {
                            const searchText = searchItem;
                            if (!searchText?.length) return null;
                            return (
                              <Button
                                className={css.searchBtn}
                                key={`search_${searchItem}`}
                                onClick={() => {
                                  handleSearchText(searchText);
                                }}
                              >
                                {searchText}
                              </Button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </>
                )}
              {/* popular searches */}
              <div className={css.searchTag}>
                <div className={css.searchTagTitle}>
                  <span>
                    <FormattedMessage id="popular_search" />
                  </span>
                </div>
                <div className={css.searchTagBtns}>
                  {searchState?.popularSearches?.map((searchItem) => {
                    const searchText =
                      searchItem?.['searchText']?.[
                        intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1)
                      ];
                    return (
                      <Button
                        className={classNames(css.searchBtn, css.popularSearchBtn)}
                        key={`search${searchItem?.searchId}`}
                        onClick={() => {
                          handleSearchText(searchText);
                        }}
                      >
                        {searchText}
                      </Button>
                    );
                  })}
                </div>
              </div>
              {pageLoader && searchResults.length === 0 ? (
                <CartSkelton />
              ) : (
                <SearchResultList
                  searchString={inputRef.current?.value || ''}
                  setPageLoader={setPageLoader}
                  products={searchResults}
                  searchTerm={searchTerm}
                />
              )}
            </div>
            {/* TODO: Add the minicart here */}
            {isDesktop && <MiniCart />}
          </div>
        </main>
        {!isDesktop && <CartBar />}

        <footer className={css.footer}></footer>
      </div>
    </>
  );
}

export default Search;
